import styles from "@/styles/shop-info/day-change-mind.module.scss";
import Link from "next/link";
import Image from "next/image";

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const imageDomain = publicRuntimeConfig.imageDomain;

export default function CompFastDeliveryContent() {
  return (
    <div className={styles["comp-day-change-mind"]}>
      <Image
        className={styles["banner-img"]}
        style={{ display: "block", margin: "0 auto" }}
        src={`${imageDomain}/legal/safe-online-shopping-banner.png`}
        alt={"crazy-points-banner"}
        width={800}
        height={139}
      ></Image>
      <div className={`${styles["ask-title"]} padding-top-16`}>
        Safe Online Shopping With Secure Payment
      </div>
      <div className={`${styles["answer-desc"]}`}>
        Online shopping in Australia is safer at CrazySales.com.au! We&apos;ve safely
        completed&nbsp;
        <Link href="/article/ShopWithHappy" legacyBehavior>
          <a rel="noopener noreferrer" className={styles["link"]}>
            over 1,000,000 transactions with over 500,000 satisfied customers.
          </a>
        </Link>
      </div>
      <div className={`${styles["answer-desc"]} padding-top-10`}>
        We use extremely safe 128 bit SSL (Secure Socket Layer) HTTPS encryption
        to protect all the information you enter on our website from prying
        eyes. We use an industry-trusted solution of McAfee SECURE software and
        RapidSSL certificates to make absolutely sure that you&apos;ll shop with
        total peace of mind.
      </div>
      <div className={`${styles["answer-desc"]} padding-top-10`}>
        We pride ourselves on our reliability and so all deliveries are made
        with full transit insurance. We always include the cost of insurance in
        the shipping cost, so there are never any hidden fees.
      </div>
      <div className={`${styles["answer-desc"]} padding-top-10`}>
        We never store credit card information. In fact, we don&apos;t even require
        it: we also happily accept payment by means of&nbsp;
        <Link href="http://www.paypal.com.au/au" legacyBehavior>
          <a rel="noopener noreferrer" className={styles["link"]}>
            PayPal
          </a>
        </Link>
        &nbsp;and&nbsp;
        <Link href="https://www.bpay.com.au/" legacyBehavior>
          <a rel="noopener noreferrer" className={styles["link"]}>
            BPAY
          </a>
        </Link>
        &nbsp;. Whatever your level of concern about transaction safety,
        CrazySales has got you covered.
      </div>
      <div className={`${styles["answer-desc"]} padding-top-10`}>
        We abide by the standards of the Australian government&apos;s National
        Privacy Principles for the Fair Handling of Personal Information, and we
        never ask for more information than we require to complete your
        transaction.
      </div>

      <div className={`${styles["answer-desc"]} padding-top-10`}>
        We hope you&apos;ll enjoy safe online shopping in Australia with CrazySales!
      </div>

      <div className={`${styles["ask-title"]} padding-top-16`}>
        Online Shopping Safety Tips
      </div>

      <div className={`${styles["answer-desc"]}`}>
        While we do everything possible on our side to ensure that your
        information is secure, there&apos;s no reason not to take precautions of your
        own. Even the world&apos;s best security can&apos;t protect you if you carelessly
        tell somebody else your password!
      </div>

      <div className={`${styles["answer-desc"]} padding-top-10`} style={{ fontWeight: "bold" }}>
        • Always make your password hard to guess.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        Always mix numbers, symbols and letters in upper and lower case. Never
        create passwords that are easy to guess from your name or date of birth.
      </div>

      <div className={`${styles["answer-desc"]} padding-top-10`} style={{ fontWeight: "bold" }}>
        • Never store your password anywhere.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        The only place information is truly safe is in your head.
      </div>

      <div className={`${styles["answer-desc"]} padding-top-10`} style={{ fontWeight: "bold" }}>
        • Don&apos;t shop online using unsecured Wi-Fi connections.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        While your connection to our website is secure, your own laptop may not
        be. Prevent identity thieves grabbing any personal information by
        avoiding the open Wi-Fi networks found in public places.
      </div>

      <div className={`${styles["answer-desc"]} padding-top-10`} style={{ fontWeight: "bold" }}>
        • Never give anyone unnecessary personal details.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        The more information you give out, the easier it is to impersonate you.
      </div>

      <div className={`${styles["answer-desc"]} padding-top-10`} style={{ fontWeight: "bold" }}>
        • Keep your computer security up to date.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        Running your computer without a firewall and antivirus software means
        you could be unwittingly sending everything you type to a third party,
        including your address, credit card number and verification codes. Be
        sure to regularly update your Browser
      </div>

      <div className={`${styles["answer-desc"]} padding-top-10`} style={{ fontWeight: "bold" }}>
        • Be careful of entering your details into a non-secure website.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        When shopping online, look at the website address (URL). If it doesn&apos;t
        begin with &quot;https&quot; (HTTP Secure), then the information you enter is not
        being encrypted between your computer and the site, and it might be
        stolen. All your shopping at CrazySales is done using an HTTPS
        connection and is secure behind 128-bit SSL encryption.
      </div>

      <Image
        className={`${styles["banner-img"]}`}
        style={{ display: "block", margin: "24px auto" }}
        src={`${imageDomain}/legal/safe-online-shopping-pic.png`}
        alt={"crazy-points-banner"}
        width={800}
        height={139}
      ></Image>
    </div>
  );
}
